module.exports = __webpack_public_path__ + "img/DNADamage-MELA_GSE185386.ba692f20.png";